import { useCallback, useState } from "react";
import { useShortcut } from "../../util/shortcuts";
import { FTLShortcutUtils } from "../../util/shortcuts/lib";
FTLShortcutUtils.register("tabNext", {
    default: "ArrowRight",
    label: "След. вкладка",
});
FTLShortcutUtils.register("tabPrev", {
    default: "ArrowLeft",
    label: "Пред. вкладка",
});
export default (initialIndex, maxIndex, disableShortcuts) => {
    const [tabIndex, setTabIndex] = useState(initialIndex);
    const goToNextTab = useCallback(() => {
        if (maxIndex > tabIndex)
            setTabIndex(tabIndex + 1);
        else
            setTabIndex(0);
    }, [tabIndex]);
    const goToPrevTab = useCallback(() => {
        if (tabIndex > 0)
            setTabIndex(tabIndex - 1);
        else
            setTabIndex(maxIndex);
    }, [tabIndex]);
    useShortcut("tabNext", () => !disableShortcuts && goToNextTab());
    useShortcut("tabPrev", () => !disableShortcuts && goToPrevTab());
    return {
        tabIndex,
        setTabIndex,
        goToNextTab,
        goToPrevTab,
    };
};
//# sourceMappingURL=useTabs.js.map